import Vue from 'vue';
import Vuex from 'vuex';
import recipes from './modules/recipes';
import user from './modules/user';
const fb = require('../../firebaseConfig.js');

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        recipes,
        user
    }
});